// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2jmxj","rootSmall":"AddTileButton_rootSmall__2j6xe"};